import { Form, Grid, Segment  } from 'semantic-ui-react';
import Loading from './Loading';
import gridsec_logo_white from '../images/gridsec_logo.png'
import Org from './Org/Org';

const MaintenanceDisplay = ({ loading, oktaAuthenticated, msAuthenticated}) => {

    if(loading){ return <Loading />}

    if((!loading && oktaAuthenticated) || (!loading && msAuthenticated)){ return <Org />}

    if(!loading && !oktaAuthenticated && !msAuthenticated){
        return (
            <Grid centered columns={2} className='login-page' style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '100vh'}}>
                <Segment raised padded="very">
                    <Form>
                        <Segment basic className='dashboard-logo-container'>
                            <img alt='gridsec_logo_white' src={gridsec_logo_white} className='dashboard-logo' style={{maxWidth: "80vh"}} />
                        </Segment>
                            <br/>
                        <h1>GridSecurity Portal is currently offline for scheduled maintenance and is expected to be back up today, June 28th, at 8:00 AM PT.</h1>
                        <div>
                            During this time, tickets can be sent via email to tickets@gridsec.com, however they will not be triaged until the end of this maintenance window.
                        </div>
                        <div>
                            Please call our Helpdesk at <a href="916-822-2078">916-822-2078</a> if you have an urgent Sev1 or Sev2 request during this maintenance window.
                        </div>
                    </Form>
                </Segment>
            </Grid>
        )
    }
}

export default MaintenanceDisplay